export const environment = {
    production: true,
    appVersion: 'v0.0.1',
    apiHost: 'https://backend.aceleradoraunoentrecienmil.org',
    avatarFolder: 'Pacientes - Avatar'
};